(function () {
  var FALLBACK_URL = '/collections/all'; // si aucun produit trouvé ou erreur

  async function fetchAllAvailableHandles() {
    var handles = [];
    var page = 1;
    var maxPages = 20;

    while (page <= maxPages) {
      var res = await fetch('/collections/all/products.json?limit=250&page=' + page);
      if (!res.ok) break;
      var data = await res.json();
      var products = data.products || [];
      if (products.length === 0) break;

      products.forEach(function (product) {
        var hasStock = product.variants.some(function (v) { return v.available; });
        if (hasStock) handles.push(product.handle);
      });

      if (products.length < 250) break;
      page++;
    }
    return handles;
  }

  async function redirectToSurprise() {
    try {
      var handles = await fetchAllAvailableHandles();
      if (handles.length === 0) {
        window.location.href = FALLBACK_URL;
        return;
      }
      var randomHandle = handles[Math.floor(Math.random() * handles.length)];
      window.location.href = '/products/' + randomHandle;
    } catch (err) {
      console.error('Erreur random product:', err);
      window.location.href = FALLBACK_URL;
    }
  }

  redirectToSurprise();
})();